import { FileFormats } from "../../../../../../../components/finalForms/libs/data/fileFormatTypes"
import { FormFieldTypes } from "../../../../../../../components/finalForms/libs/data/formFieldType"
import { validationTypes } from "../../../../../../../components/finalForms/libs/data/ValidationTypes"


const initState = {
    scopesImportFile: null
}

export const importContractRenewals = {
    name: "Scopes Import Section",
    initialState: initState,
    section: [
        {
            sectionId: "scopesImportSection",
            title: "Scopes Import Section",
            row: {},
            style: {
                sectionStyle: "col-lg-12 col-md-12",
            },
            wrapperTemplate: <div className="row"></div>,
            fields: [
                {
                    id: "scopesImportFile",
                    label: "",
                    Field_Name: "file",
                    fieldType: FormFieldTypes.FILE,
                    dataField: "scopesImportFile",
                    fieldSetting: {
                        placeholder: 'Select Scopes File',
                        allowMultipleFiles: false,
                        acceptedFileFormats: [
                            FileFormats.XLSX,
                        ],
                        minFileSizeInMB: 0,
                        maxFileSizeInMB: 3,
                    },
                    validation: [
                        // { type: validationTypes.REQUIRE },
                        { type: validationTypes.FILE },
                    ],
                    style: {
                        containerCss: "col-12 mb-1",
                    },
                },
            ]
        }
    ]
}